import Loadable from '../../../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "business-misc-privacy" */ './index')
);
